import React from "react";

const TitleSkeleton = () => {
  return <h1 className="h-9 w-full rounded-md bg-gray-300"></h1>;
};

export default TitleSkeleton;
